module.exports = __webpack_public_path__ + "img/android.650d6c06.png";